import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="15.926" height="16.755" viewBox="0 0 15.926 16.755">
    <g
      id="Icon_feather-arrow-left"
      data-name="Icon feather-arrow-left"
      transform="translate(-6.5 -6.086)"
    >
      <path
        id="Caminho_306"
        data-name="Caminho 306"
        d="M21.426,18H7.5"
        transform="translate(0 -3.537)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Caminho_307"
        data-name="Caminho 307"
        d="M14.463,21.426,7.5,14.463,14.463,7.5"
        transform="translate(0 0)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>,
  'LeftColorIcon',
);
